import gas from './client';
const headers = {
    Accept: `application/vnd.synchronoss.gas-1.0+json`,
    'Content-Type': `application/vnd.synchronoss.gas-1.0+json`,
};
const apiType = 'gas';
const opts = {
    headers: {
        Accept: '*/*',
        'Content-Type': `application/vnd.synchronoss.gas-1.0+json`,
    },
};
/**
 * editMemberName and resendInvite are using
 */
export const sendRequest = async (endPoint, action, data, logger) => {
    logger ? gas.setLogger(logger) : undefined;
    let url = `/group/{userId}/${endPoint}`;
    if (action === 'resend') {
        url += '/resend';
    }
    const requestData = action === 'edit' ? { data, headers } : { headers };
    return gas.put(url, apiType, requestData);
};
export const inviteMember = (endPoint, { email, firstName, lastName }, logger) => {
    logger ? gas.setLogger(logger) : undefined;
    return gas.post(`/group/{userId}/${endPoint}`, apiType, {
        data: { email, firstName, lastName },
        headers,
    });
};
/**
 * revokeInvite and removeInvite are using
 * @param endPoint
 * @param resourceId
 * @param logger
 */
export const deleteResource = async (endPoint, resourceId, logger) => {
    logger ? gas.setLogger(logger) : undefined;
    return gas.delete(`/group/{userId}/${endPoint}/${resourceId}`, apiType, { headers });
};
export const fetchWrapper = async (request, resolvedefault) => {
    try {
        const response = await request();
        return new Promise((resolve) => resolve(response));
    }
    catch (e) {
        return new Promise((resolve) => resolve(resolvedefault));
    }
};
export const fetchGroup = async (endpoint, headers, logger) => {
    logger ? gas.setLogger(logger) : undefined;
    return gas.get(`/group/{userId}/${endpoint}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
